var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Badge } from 'reactstrap';
import cxs from 'cxs';
import moment from 'moment';
import SlotStats from './SlotStats';
import ChannelBreakdown from './ChannelBreakdown';
import GroupNameSection from './GroupNameSection';
import BlocksSection from './BlockSection';
var styles = {
    section: cxs({
        marginBottom: '20px'
    }),
    sectionTitle: cxs({
        fontSize: '0.9rem',
        fontWeight: 600,
        color: '#495057',
        marginBottom: '10px',
        borderBottom: '1px solid #dee2e6',
        paddingBottom: '6px'
    }),
    statGrid: cxs({
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '12px'
    }),
    statItem: cxs({
        textAlign: 'center',
        padding: '12px',
        backgroundColor: '#f8f9fa',
        borderRadius: '6px'
    }),
    statValue: cxs({
        fontSize: '1.5rem',
        fontWeight: 700,
        color: '#333'
    }),
    statLabel: cxs({
        fontSize: '0.75rem',
        color: '#6c757d',
        textTransform: 'uppercase'
    }),
    channelList: cxs({
        fontSize: '0.85rem'
    }),
    channelItem: cxs({
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 0',
        borderBottom: '1px solid #eee'
    }),
    groupNameDisplay: cxs({
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    }),
    blockTable: cxs({
        fontSize: '0.85rem'
    }),
    actionButtons: cxs({
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap'
    })
};
var SlotDetailModal = /** @class */ (function (_super) {
    __extends(SlotDetailModal, _super);
    function SlotDetailModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            editingGroupName: false,
            groupNameInput: '',
            showBlockForm: false,
            blockQuantity: 1,
            blockReason: ''
        };
        _this.handleClose = function () {
            _this.props.store.closeModal();
        };
        _this.handleToggleSales = function () {
            var _a;
            var store = _this.props.store;
            if ((_a = store.selectedSlot) === null || _a === void 0 ? void 0 : _a.id) {
                store.toggleSalesOpen(store.selectedSlot.id);
            }
        };
        _this.handleSaveGroupName = function () {
            var _a;
            var store = _this.props.store;
            if ((_a = store.selectedSlot) === null || _a === void 0 ? void 0 : _a.id) {
                var name = _this.state.groupNameInput.trim() || null;
                store.setGroupName(store.selectedSlot.id, name);
                _this.setState({ editingGroupName: false });
            }
        };
        _this.handleAddBlock = function () {
            var _a;
            var store = _this.props.store;
            if (((_a = store.selectedSlot) === null || _a === void 0 ? void 0 : _a.id) && _this.state.blockQuantity > 0) {
                store.addBlock(store.selectedSlot.id, {
                    quantity: _this.state.blockQuantity,
                    reason: _this.state.blockReason || 'Sin especificar'
                });
                _this.setState({
                    showBlockForm: false,
                    blockQuantity: 1,
                    blockReason: ''
                });
            }
        };
        _this.handleRemoveBlock = function (blockId) {
            var _a;
            var store = _this.props.store;
            if ((_a = store.selectedSlot) === null || _a === void 0 ? void 0 : _a.id) {
                store.removeBlock(store.selectedSlot.id, blockId);
            }
        };
        return _this;
    }
    SlotDetailModal.prototype.componentDidUpdate = function (prevProps) {
        var store = this.props.store;
        if (store.selectedSlot && !prevProps.store.selectedSlot) {
            this.setState({
                groupNameInput: store.selectedSlot.groupName || '',
                editingGroupName: false,
                showBlockForm: false,
                blockQuantity: 1,
                blockReason: ''
            });
        }
    };
    SlotDetailModal.prototype.render = function () {
        var _a;
        var store = this.props.store;
        var slot = store.selectedSlot;
        if (!slot)
            return null;
        var experienceName = ((_a = store.experiences.find(function (e) { return e.id === slot.experience_id; })) === null || _a === void 0 ? void 0 : _a.name) || '';
        return (React.createElement(Modal, { isOpen: store.modalOpen, toggle: this.handleClose, size: "lg" },
            React.createElement(ModalHeader, { toggle: this.handleClose },
                React.createElement("div", null,
                    React.createElement("strong", null, slot.time),
                    " - ",
                    moment(slot.date).format('dddd, D MMMM YYYY')),
                React.createElement("small", { className: "text-muted" }, experienceName)),
            React.createElement(ModalBody, null,
                React.createElement("div", { className: "mb-3" },
                    slot.salesOpen ? (React.createElement(Badge, { color: "success" }, "Venta abierta")) : (React.createElement(Badge, { color: "secondary" }, "Venta cerrada")),
                    slot.hasOverbooking && (React.createElement(Badge, { color: "danger", className: "ml-2" }, "Overbooking"))),
                React.createElement("div", { className: styles.section },
                    React.createElement("div", { className: styles.sectionTitle }, "Ocupaci\u00F3n"),
                    React.createElement(SlotStats, { slot: slot })),
                React.createElement("div", { className: styles.section },
                    React.createElement("div", { className: styles.sectionTitle }, "Ventas por canal"),
                    React.createElement(ChannelBreakdown, { slot: slot })),
                React.createElement("div", { className: styles.section },
                    React.createElement("div", { className: styles.sectionTitle }, "Nombre de grupo"),
                    React.createElement(GroupNameSection, { slot: slot, onSave: this.handleSaveGroupName })),
                React.createElement("div", { className: styles.section },
                    React.createElement("div", { className: styles.sectionTitle }, "Bloqueos"),
                    React.createElement(BlocksSection, { slot: slot, onAddBlock: this.handleAddBlock, onRemoveBlock: this.handleRemoveBlock }))),
            React.createElement(ModalFooter, null,
                React.createElement("div", { className: styles.actionButtons },
                    React.createElement(Button, { color: slot.salesOpen ? 'secondary' : 'success', onClick: this.handleToggleSales }, slot.salesOpen ? '🔒 Cerrar venta' : '🔓 Abrir venta'),
                    React.createElement(Button, { color: "primary", outline: true }, "Ver reservas")),
                React.createElement(Button, { color: "secondary", outline: true, onClick: this.handleClose }, "Cerrar"))));
    };
    SlotDetailModal = __decorate([
        observer
    ], SlotDetailModal);
    return SlotDetailModal;
}(Component));
export default SlotDetailModal;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/components/SlotDetailModal.tsx
// module id = 1613
// module chunks = 0